<template>
    <v-dialog v-model="modal" width="900">
        <v-card>
            <div v-for="(offer, index) in limitedOffers" :key="offer.name + index">
                <component
                    :is="component"
                    :key="index"
                    :offer="offer"
                    :search-request="searchRequest"
                    :initial-selected-offer-keys="selectedOfferKeys"
                    is-package
                    is-tour
                    @change-selected-offer-keys="changeSelectedOfferKeys"
                >
                    <template v-slot:price="{room}">
                        <tour-offer-delta-button
                            v-if="!searchRequest.rooms || (searchRequest.rooms && searchRequest.rooms.length === 1)"
                            :room="room"
                            :offer-key="offerKey"
                            :entry-name="entry.entryName"
                        />
                        <tour-multiple-room-offer-delta
                            v-else
                            :room="room"
                            :offer-key="offerKey"
                            :entry-name="entry.entryName"
                            :hotel-offer="offer"
                            class="pe-5"
                        />
                    </template>
                    <template v-slot:multiRoomSelect>
                        <div class="text-center">
                            <v-btn color="primary" class="mb-4" @click="modal = false">
                                {{ $t('select') }}
                            </v-btn>
                        </div>
                    </template>
                </component>
            </div>
            <div
                v-if="entry.offers && entry.offers.length > offersShownLength"
                class="d-flex py-4 justify-center"
                style="background-color: white"
            >
                <v-btn
                    variant="flat"
                    size="small"
                    color="primary"
                    @click.stop="offersShownLength = offersShownLength + offerLimitStep"
                >
                    {{ $t('show_more') }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_TOUR_HOTEL_INFO} from '@/utils/event-bus'
    import TourOfferDeltaButton from '@/components/tours/search/TourOfferDeltaButton.vue'
    import TourMultipleRoomOfferDelta from '@/components/tours/search/TourMultipleRoomOfferDelta.vue'
    import HotelOfferCard from '@/components/search/offers/HotelOfferCard.vue'
    import HotelOfferCardMobile from '@/components/search/offers/HotelOfferCardMobile.vue'

    @Component({
        components: {
            TourMultipleRoomOfferDelta,
            HotelOfferCard,
            HotelOfferCardMobile,
            TourOfferDeltaButton,
        },
    })
    export class TourHotelInfoModal extends Vue {
        @Prop({required: true}) searchRequest

        modal = false
        entry = {}
        offerKey = null
        selectedOfferKeys = []

        offerLimitStep = 2
        offersShownLength = 2

        mounted() {
            EventBus.$on(SHOW_TOUR_HOTEL_INFO, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_TOUR_HOTEL_INFO, this.showModal)
        }

        showModal({entry, offerKey}) {
            this.offersShownLength = 2
            this.entry = entry
            this.entry.offers = [...this.entry.offers].sort(
                (a, b) => a.rooms[0].notDeltaPrice.amount - b.rooms[0].notDeltaPrice.amount
            )
            this.offerKey = offerKey
            if (entry.selectedOfferKeys) this.selectedOfferKeys = entry.selectedOfferKeys
            this.modal = true
        }

        changeSelectedOfferKeys(selectedOfferKeys) {
            toursRuntimeStore.SELECT_OFFER({
                offerKey: this.offerKey,
                selectedOfferKey: selectedOfferKeys[0],
                selectedOfferKeys,
            })
        }

        get limitedOffers() {
            return this.entry.offers?.slice(0, this.offersShownLength) || []
        }

        get component() {
            return !this.$breakpoint.smAndDown
                ? resolveComponent('HotelOfferCard')
                : resolveComponent('HotelOfferCardMobile')
        }
    }

    export default TourHotelInfoModal
</script>
